import { useCallback, useEffect, useRef } from 'react';
import axios from 'axios';
import { useUserIdentification } from '../../../../utils/hooks';
import { notification } from '../../../../utils/messaging';

const AUTH_REQUEST_CONFIG = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};

export const useAnglerSession = (isLoggedInState, loadingState) => {
  const [isLoggedIn, setIsLoggedIn] = isLoggedInState;
  const [loading, setLoading] = loadingState;
  const sessionChecked = useRef(false);
  const { resetIdentity } = useUserIdentification();

  // The layout passes new setter functions on every render, so only check the session once.
  useEffect(() => {
    if (sessionChecked.current) {
      return;
    }
    sessionChecked.current = true;
    axios
      .get('auth', AUTH_REQUEST_CONFIG)
      .then((res) => {
        setIsLoggedIn(res.status === 200);
        setLoading(res.status !== 200);
      })
      .catch(() => {
        setIsLoggedIn(false);
        setLoading(false);
      });
  }, [setIsLoggedIn, setLoading]);

  const handleLogOut = useCallback(async () => {
    try {
      await axios.get('/angler/refresh-revoke', AUTH_REQUEST_CONFIG);
      await axios.get('/angler/access-revoke', AUTH_REQUEST_CONFIG);
    } catch {
      return;
    }
    resetIdentity();
    if (window.location.pathname === '/user/profile') {
      notification.success({ description: 'Successfully logged out' });
      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
      return;
    }
    window.location.reload();
  }, [resetIdentity]);

  return { isLoggedIn, loading, handleLogOut };
};
